import { render } from "./rateView.vue?vue&type=template&id=bcc66a5e"
import script from "./rateView.vue?vue&type=script&lang=js"
export * from "./rateView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__